import {
  AccountInfo,
  IPublicClientApplication,
  InteractionRequiredAuthError,
  LogLevel,
  SilentRequest,
} from '@azure/msal-browser'

export const loginRequest = {
  AD: {
    scopes: ['User.Read'],
  },
  B2C: {
    scopes: [],
  },
}

export const system = {
  asyncPopups: true,
  loggerOptions: {
    loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
      if (containsPii) {
        return
      }
      switch (level) {
        case LogLevel.Error:
          console.error(message)
          return
        case LogLevel.Info:
          console.info(message)
          return
        case LogLevel.Verbose:
          console.debug(message)
          return
        case LogLevel.Warning:
          console.warn(message)
          return
        default:
          return
      }
    },
  },
  pollIntervalMilliseconds: 0,
}

export const cache = {
  cacheLocation: 'localStorage',
  storeAuthStateInCookie: false,
}

export function handleRedirectLogin(Instance: IPublicClientApplication) {
  Instance.handleRedirectPromise()
    .then((a) => {
      if (a?.account) {
        Instance.setActiveAccount(a?.account)
      }
    })
    .catch((err) => {
      console.error(err)
    })
}

export async function AcquireToken(Instance: IPublicClientApplication, lr: SilentRequest, account: AccountInfo) {
  try {
    const response = await Instance.acquireTokenSilent({
      ...lr,
      account,
    })
    return response
  } catch (e) {
    if (e === InteractionRequiredAuthError) {
      Instance.handleRedirectPromise()
        .then((a) => {
          if (a?.account) {
            Instance.setActiveAccount(a?.account)
          }
        })
        .catch((err) => {
          console.error(err)
        })
    }
    return Promise.reject(new Error('error'))
  }
}
